import { Component, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import '../style/app.scss';

declare var $: any;
declare const window: any;

@Component({
  selector: 'wm-app',
  template: require('./app.component.html'),
})
export class AppComponent implements AfterViewInit {
  constructor(private translate: TranslateService, public router: Router) {
    translate.addLangs(['en', 'ru']);
    translate.setDefaultLang('ru');

    // let browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|ru/) ? browserLang : 'ru');
    translate.use('ru');
  }

  ngAfterViewInit() {
    $('body').append(
      $('<script src="https://assets.webmoney.ru/js/wm-ext-menu.js"></script>'),
      $('<script src="https://assets.webmoney.ru/js/wm-ext-search.js"></script>'),
      $('<script src="https://illicium.wmtransfer.com/scripts/public/illicium_0_3.js" async></script>')
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts